@if (showKeepAlive) {
    <ap-keep-alive
        [timeToThreshold]="timeToThreshold"
        [timeToEnd]="timeToEnd"
        (heartbeat)="keepAlive()"
        (onKeepAliveModalClosed)="keepAliveModalClosed($event)"
    >
    </ap-keep-alive>
}
<div class="mijn-omgeving" [class.canvas-mobile]="isMobileRoute" mijn-analyse>
    <auth0session></auth0session>
    <mijn-omgeving-template [templateSettings]="templateSettings | async" [currentTemplate]="currentTemplate | async">
        <router-outlet></router-outlet>
    </mijn-omgeving-template>
</div>
